function isLocalStorageEnable() {
    return navigator?.cookieEnabled && Boolean(window?.localStorage);
}

export function setLocalStorage({ key, value }) {
    const item = {
        value
    };
    try {
        if (isLocalStorageEnable()) {
            localStorage.setItem(key, JSON.stringify(item));
        } else {
            console.log('Failed to access window local storage');
        }
    } catch (error) {
        if (error.name === 'NS_ERROR_FILE_CORRUPTED') {
            // Firefox browser error: https://stackoverflow.com/questions/18877643/error-in-local-storage-ns-error-file-corrupted-firefox
            console.log('Firefox storage has been corrupted when set local storage', error);
        } else {
            console.log('Failed to set local storage', error);
        }
    }

    return item;
}

export const getLoginSeverKeyPutIntoLocalParams = () => ({
    key: 'isfirstPassLoginSever',
    value: 'isfirstPassLoginSever'
});

export function getLocalStorage({ key }) {
    try {
        return isLocalStorageEnable() ? JSON.parse(localStorage.getItem(key)) : undefined;
    } catch (error) {
        if (error.name === 'NS_ERROR_FILE_CORRUPTED') {
            // Firefox browser error: https://stackoverflow.com/questions/18877643/error-in-local-storage-ns-error-file-corrupted-firefox
            console.log('Firefox storage has been corrupted when get local storage', error);
        } else {
            console.log('Failed to get local storage', error);
        }
    }
}

export function deleteLocalStorage({ key }) {
    try {
        if (isLocalStorageEnable()) {
            localStorage.removeItem(key);
        }
    } catch (error) {
        if (error.name === 'NS_ERROR_FILE_CORRUPTED') {
            // Firefox browser error: https://stackoverflow.com/questions/18877643/error-in-local-storage-ns-error-file-corrupted-firefox
            console.log('Firefox storage has been corrupted when delete local storage', error);
        } else {
            console.log('Failed to delete local storage', error);
        }
    }
}
